import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { getPublicationTypeLabel } from '../../../constants/publicationTypes'
import RequestsHighlights from '../../dashboard/requests/RequestsHighlights'

const specializedServices = [
  {
    id: 'custodia',
    title: 'Custodia de carga',
    description: 'Escolta armada y monitoreo 24/7 para rutas críticas.',
    price: 'Desde $8,500',
    image: '/Images/type/Custodia.png',
    categorySlug: 'service_security',
  },
  {
    id: 'aduanas',
    title: 'Gestión aduanal',
    description: 'Despacho, clasificación y trámites en frontera.',
    price: 'Desde $5,900',
    image: '/Images/type/GestionAduanal.png',
    categorySlug: 'customs_agent',
  },
  {
    id: 'almacen',
    title: 'Cross-dock & almacenaje',
    description: 'Red de bodegas certificadas con inventario en tiempo real.',
    price: 'Desde $12,200',
    image: '/Images/type/Almacenaje.png',
    categorySlug: 'product',
  },
  {
    id: 'refrigerado',
    title: 'Cadena fría premium',
    description: 'Unidades refrigeradas con registro IoT.',
    price: 'Desde $15,400',
    image: '/Images/type/CadenaFria.png',
    categorySlug: 'service_ground_transport',
  },
  {
    id: 'seguro',
    title: 'Seguros de carga',
    description: 'Coberturas door-to-door con tracking de siniestros en vivo.',
    price: 'Desde $3,200',
    image: '/Images/type/Seguros.png',
    categorySlug: 'service_security',
  },
  {
    id: 'proyectos',
    title: 'Proyectos especiales',
    description: 'Planeación logística para sobredimensionados y movimientos críticos.',
    price: 'Desde $18,700',
    image: '/Images/type/Proyectos.png',
    categorySlug: 'freight_forwarder',
  },
]

export function SpecializedServicesSection() {
  const navigate = useNavigate()

  const handleNavigateToMarketplace = useCallback(
    service => {
      if (!service) return
      const params = new URLSearchParams()
      if (service.categorySlug) {
        const categoryLabel = getPublicationTypeLabel(service.categorySlug)
        params.set('category', categoryLabel)
        params.set('categorySlug', service.categorySlug)
      } else if (service.title) {
        params.set('quickSearch', service.title)
      }
      const searchQuery = params.toString()
      navigate(searchQuery ? `/marketplace?${searchQuery}` : '/marketplace')
    },
    [navigate]
  )

  const handleKeyDown = (event, service) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleNavigateToMarketplace(service)
    }
  }

  return (
    <section className="specialized-section" aria-labelledby="specialized-title">
      <div className="specialized-section__inner">
        <div className="specialized-section__header">
          <div>
            <p className="specialized-section__eyebrow">Servicios especializados</p>
            <h2 id="specialized-title">Custodia, aduanas y logística crítica</h2>
            <p className="specialized-section__description">
              Integra servicios de seguridad, trámites y soporte operativo desde un solo panel.
            </p>
          </div>
        </div>

        <div className="specialized-grid">
          {specializedServices.map(service => (
            <article
              className="special-card special-card--interactive"
              key={service.id}
              role="button"
              tabIndex={0}
              onClick={() => handleNavigateToMarketplace(service)}
              onKeyDown={event => handleKeyDown(event, service)}
              aria-label={`${service.title}, ver proveedores relacionados en Marketplace`}
            >
              <div className="special-card__media">
                <img src={service.image} alt={service.title} loading="lazy" />
              </div>
              <div className="special-card__body">
                <div className="special-card__content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <RequestsHighlights />
      </div>
    </section>
  )
}
